import { render, staticRenderFns } from "./ProfileBlock.vue?vue&type=template&id=008ed074&"
import script from "./ProfileBlock.vue?vue&type=script&lang=js&"
export * from "./ProfileBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports